import { workflowComponent } from '@banking/ui/services/bank-accounts';
import { goNextPageDisabled, goPrevPageDisabled, userClickAddExternalBankAccountAction, userClickCancelVerificationAction, userClickChangeBankAccountAction, userClickNextPageAction, userClickPrevPageAction, userClickResendEmailAction, userClickUseCheckingAction } from '@banking/ui/workflows/bank-accounts/all-locations';
import { hbs } from 'ember-cli-htmlbars';
const template = hbs`
  <Banking::BankAccounts::AllLocations
    @allMerchantLocations={{this.displayedRows}}
    @externalBankAccounts={{this.externalBankAccounts}}
    @onUserClickAddExternalBankAccount={{this.onUserClickAddExternalBankAccount}}
    @onUserClickCancelVerification={{this.onUserClickCancelVerification}}
    @onUserClickChangeBankAccount={{this.onUserClickChangeBankAccount}}
    @onUserClickResendEmail={{this.onUserClickResendEmail}}
    @onUserClickUseChecking={{this.onUserClickUseChecking}}
    @currentPageNumber={{this.currentPage}}
    @goLeft={{this.onUserClickPrevPage}}
    @goLeftDisabled={{this.goLeftDisabled}}
    @goRight={{this.onUserClickNextPage}}
    @goRightDisabled={{this.goRightDisabled}}
    @lastPageNumber={{this.lastPage}}
    @showPagination={{this.showPagination}}
    @allLocationDescription={{this.allLocationDescription}}
    @isAccountOwner={{this.isAccountOwner}}
  />`;
const mapStateToProps = state => ({
  currentPage: state.allLocations.currentPage,
  displayedRows: state.allLocations.displayedRows,
  goLeftDisabled: goPrevPageDisabled(state.allLocations),
  goRightDisabled: goNextPageDisabled(state.allLocations),
  lastPage: state.allLocations.lastPage,
  showPagination: state.allLocations.showPagination,
  externalBankAccounts: state.externalBankAccounts.allRows,
  allLocationDescription: state.allLocations.allLocationDescription,
  isAccountOwner: state.allLocations.isAccountOwner
});
const mapActionsToProps = () => ({
  onUserClickAddExternalBankAccount: userClickAddExternalBankAccountAction,
  onUserClickCancelVerification: userClickCancelVerificationAction,
  onUserClickChangeBankAccount: userClickChangeBankAccountAction,
  onUserClickNextPage: userClickNextPageAction,
  onUserClickPrevPage: userClickPrevPageAction,
  onUserClickResendEmail: userClickResendEmailAction,
  onUserClickUseChecking: userClickUseCheckingAction
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);